/* eslint-disable no-multi-str */
import React from 'react'
import {
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  FormRow,
  GalleryDropzonePreview,
  GalleryForm,
  ImagePickerSidebar,
  RequiredLabel,
  SpecialRequiredLabel,
} from '../../../components'
import { Editor } from '@tinymce/tinymce-react'
import { updateForm } from '../../../features/blog-form/slice'
import { useDispatch, useSelector } from 'react-redux'
import debounce from 'lodash.debounce'
import { addToHolder } from '../../../features/blog-form/slice'
import { TINYMCE_API_KEY } from '../../../api'
import { useInternationalization } from '../../../features/i18n'
import { SidebarStatus } from './sidebar-status'
import { useViewport } from '../../../utils'

const Form = ({isEdit}) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = React.useState(true)
  const form = useSelector(state => state.blogForm.data)
  const { translate } = useInternationalization()
  const { isDesktop } = useViewport()

  const handleInput = debounce((e) => {
    if(e.target && e.target !== null){
      const key = e.target.name
      const value = e.target.value
      dispatch(updateForm({key, value}))
    }
  }, 250)

  const handleEditorChange = (name, value) => {
    console.log({name, value})
    // handleInput({
    //   target: {
    //     name,
    //     value
    //   }
    // })

    dispatch(updateForm({key: name, value}))
  }

  const handleImage = (e) => {
    if (e) {
      console.log(e)
      const blob = URL.createObjectURL(e)

      handleInput({
        target: {
          name: 'image',
          value: {
            name: e.name,
            type: e.type,
            blob
          }
        }
      })
    }
  }

  const handleGalleryChange = (res) => {
    const { images, blobs } = res
    const input = {
      target: {
        name: 'gallery',
        value: blobs.map((blob, index) => {
          return {
            blob,
            name: images[index].name,
            type: images[index].type,
          }
        })
      }
    }

    console.log(input)

    handleInput(input)
  }

  const handleDeleteGalleryItem = (index) => {
    console.log('delete this gallery item:', form.gallery_saved[index])
    const id = form.gallery_saved[index].pkId

    // Effect 1: add to holder
    dispatch(addToHolder({entity: 'gallery', type: 'delete', id}))

    // Experiment: create holder inside form
    setTimeout(() => {
      const currentHolder = form.gallery_holder_delete ?
        [...form.gallery_holder_delete] : []
      currentHolder.push(id)
      console.log(currentHolder)
      handleInput({
        target: {
          name: 'gallery_holder_delete',
          value: currentHolder
        }
      })
    }, 300)

    // Effect 2: change UI
    const input = {
      target: {
        name: 'gallery_saved',
        value: form.gallery_saved.filter((g, i) => i !== index)
      }
    }
    handleInput(input)
  }

  return (
    <div>
      {
        !isDesktop &&
        <SidebarStatus isEdit={isEdit}/>
      }

      <p className="text-lg font-bold mb-5 lg:mb-8">
        {translate('GENERAL', 'title')}
      </p>
      <FormRow>
        <Label>{translate('GENERAL', 'title')} ({translate('LANGUAGE', 'en')}) <RequiredLabel /></Label>
        <Input
          required
          className="w-full"
          name="title_en"
          defaultValue={form.title_en}
          onChange={(e) => {e.persist(); handleInput(e)}}
        />
      </FormRow>
      <FormRow last>
        <Label>{translate('GENERAL', 'title')} ({translate('LANGUAGE', 'id')}) <RequiredLabel /></Label>
        <Input
          required
          className="w-full"
          name="title_id"
          defaultValue={form.title_id}
          onChange={(e) => {e.persist(); handleInput(e)}}
        />
      </FormRow>

      <FormRow>
        <ImagePickerSidebar
          label={translate('GENERAL', 'main_image')}
          height="200px"
          buttonWidth="160px"
          message={translate('GENERAL', 'image_warning')}
          defaultValue={form.image?.blob}
          onChange={handleImage}
        />
      </FormRow>

      <hr className="mb-8"/>

      <p className="text-lg font-bold mb-4">{translate('GENERAL', 'content')}</p>
      <div className="mb-5 lg:mb-8">
        <SpecialRequiredLabel />
      </div>

      <div className="mb-5 lg:mb-8">
        {
          loading &&
          <div>loading editor...</div>
        }
        <div className="mb-5 lg:mb-8">
          {
            !loading &&
            <Label>{translate('GENERAL', 'content')} ({translate('LANGUAGE', 'en')})*</Label>
          }
          <Editor
            apiKey={TINYMCE_API_KEY}
            value={form.content_en}
            init={{
              height: 500,
              menubar: false,
              plugins: [
                'advlist autolink lists link charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount'
              ],
              toolbar:
                'undo redo | formatselect | bold italic backcolor link | \
                alignleft aligncenter alignright alignjustify | \
                bullist numlist outdent indent | removeformat | help'
            }}
            onEditorChange={(value) => handleEditorChange('content_en', value)}
            onInit={() => setLoading(false)}
          />
        </div>
        <div className="mb-5 lg:mb-8">
          {
            !loading &&
            <Label>{translate('GENERAL', 'content')} ({translate('LANGUAGE', 'id')})*</Label>
          }
          <Editor
            apiKey={TINYMCE_API_KEY}
            value={form.content_id}
            init={{
              height: 500,
              menubar: false,
              plugins: [
                'advlist autolink lists link charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount'
              ],
              toolbar:
                'undo redo | formatselect | bold italic backcolor link | \
                alignleft aligncenter alignright alignjustify | \
                bullist numlist outdent indent | removeformat | help'
            }}
            onEditorChange={(value) => handleEditorChange('content_id', value)}
            onInit={() => setLoading(false)}
          />
        </div>

        <GalleryForm onChange={handleGalleryChange}/>

        {
          (form.gallery_saved && form.gallery_saved.length > 0) &&
          <div className="mt-8">
            {/* Saved Gallery Preview */}
            <Label>{translate('GENERAL', 'gallery')} (Database)</Label>
            <GalleryDropzonePreview
              items={form.gallery_saved?.map(d => d.url)}
              onRemove={handleDeleteGalleryItem}
            />
          </div>
        }
      </div>
    </div>
  )
}

export { Form }
